var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap",style:(_vm.contactNumberStyle)},[(_vm.hasStart)?_c('span',{staticClass:"start",staticStyle:{"color":"#f04134"}},[_vm._v("* ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }